import React from 'react';
import PropTypes from 'prop-types';
import MultimediaAttachment from './MultimediaAttachment';
import './Attachment.css';

const VideoAttachment = ({
  attachment: { url, key, type },
  originalFilename,
  ...props
}) => {
  return (
    <MultimediaAttachment attachment={{ url, key, type }} originalFilename={originalFilename}>
      <video controls width={320} style={{ marginTop: 8 }}>
        <source type={type} src={url} />
        Sorry, your browser doesn't support embedded videos.
      </video>
    </MultimediaAttachment>
  );
};

VideoAttachment.propTypes = {
  attachment: PropTypes.shape({
    url: PropTypes.string,
    key: PropTypes.string,
    type: PropTypes.string
  }),
  originalFilename: PropTypes.string
};

export default VideoAttachment;
